import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, UserRound } from "lucide-react";
import { useAuth } from "../lib/auth";
import { Chuckle, Drip, Shiver } from "./Characters";
import { PinkButton } from "./Buttons";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { id: "how-it-works", label: "How it works" },
  { id: "showcase", label: "Showcase" },
  { id: "signup", label: "Sign up" },
];

export const Logo = ({ testId }) => (
  <a href="#top" data-testid={testId} onClick={(e) => { e.preventDefault(); scrollToId("top"); }} className="group flex items-center gap-2 rounded-full text-paper">
    <span className="flex -space-x-1.5 transition-transform duration-300 group-hover:-rotate-6">
      <Chuckle className="h-7 w-7" /><Drip className="h-7 w-7" /><Shiver className="h-7 w-7" />
    </span>
    <span className="font-head text-2xl leading-none">convey</span>
  </a>
);

export const Nav = ({ onOpenSignup }) => {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const filmLabel = user ? "My entries" : "Filmmaker login";
  const filmTo = user ? "/account" : "/login";
  const go = (id) => { setOpen(false); scrollToId(id); };
  return (
    <header data-testid="nav-container" className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-ink/85 backdrop-blur-xl">
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-3 px-4 sm:px-6 lg:px-10" aria-label="Main">
        <Logo testId="nav-logo" />
        <ul className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <li key={l.id}>
              <a href={`#${l.id}`} data-testid={`nav-link-${l.id}`} onClick={(e) => { e.preventDefault(); go(l.id); }} className="link-underline font-body font-semibold text-paper/90 hover:text-paper">{l.label}</a>
            </li>
          ))}
          <li>
            <Link to={filmTo} data-testid="nav-filmmaker-login" className="inline-flex items-center gap-1.5 rounded-full border-2 border-white/25 px-4 py-1.5 font-body font-semibold text-paper hover:border-paper">
              <UserRound size={16} /> {filmLabel}
            </Link>
          </li>
        </ul>
        <div className="flex items-center gap-2">
          <PinkButton data-testid="nav-cta-get-free-pack" onClick={() => onOpenSignup("pack")} className="!px-4 !py-2 !text-sm sm:!text-base">Get the free pack</PinkButton>
          <button type="button" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} data-testid="nav-menu-toggle" onClick={() => setOpen((o) => !o)} className="grid h-10 w-10 place-items-center rounded-full text-paper hover:bg-white/10 md:hidden">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </nav>
      {open && (
        <ul data-testid="nav-mobile-menu" className="border-t border-white/10 px-4 pb-5 pt-2 md:hidden">
          {LINKS.map((l) => (
            <li key={l.id}>
              <a href={`#${l.id}`} data-testid={`nav-mobile-link-${l.id}`} onClick={(e) => { e.preventDefault(); go(l.id); }} className="block rounded-2xl px-3 py-3 font-head text-xl text-paper hover:bg-white/10">{l.label}</a>
            </li>
          ))}
          <li>
            <Link to={filmTo} data-testid="nav-mobile-filmmaker-login" className="flex items-center gap-2 rounded-2xl px-3 py-3 font-head text-xl text-paper hover:bg-white/10"><UserRound size={20} /> {filmLabel}</Link>
          </li>
        </ul>
      )}
    </header>
  );
};
